import {useState, useCallback} from 'react'
import {PeopleIcon} from '@primer/octicons-react'
import {useAddSuggestedReviewer} from '../../../../mutations/use-add-suggested-reviewer'
import {ActionItemGroup} from '../ActionItemGroup'
import type {SuggestedReviewer} from '../../../../page-data/payloads/review-requests'

interface SuggestedReviewersProps {
  suggestedReviewers: SuggestedReviewer[]
}

export function SuggestedReviewers({suggestedReviewers}: SuggestedReviewersProps) {
  const {mutate: addSuggestedReviewer} = useAddSuggestedReviewer()

  const [addedLogins, setAddedLogins] = useState<Set<string>>(() => new Set())

  const handleAddSuggestedReviewer = useCallback(
    (login: string) => {
      setAddedLogins(prev => new Set([...prev, login]))
      addSuggestedReviewer(
        {reviewerLogin: login},
        {
          onError: () => {
            setAddedLogins(prev => {
              const next = new Set(prev)
              next.delete(login)
              return next
            })
          },
        },
      )
    },
    [addSuggestedReviewer],
  )

  const remaining = suggestedReviewers.filter(({reviewer}) => !addedLogins.has(reviewer.displayLogin))

  if (remaining.length === 0) return null

  return (
    <ActionItemGroup
      icon={PeopleIcon}
      title="Add suggested reviewers"
      count={remaining.length}
      items={remaining.map(({reviewer, description}) => ({
        title: reviewer.displayLogin,
        description,
        action: {
          onClick: () => handleAddSuggestedReviewer(reviewer.displayLogin),
          label: 'Add reviewer',
          ariaLabel: `Add reviewer: @${reviewer.displayLogin}`,
        },
      }))}
    />
  )
}
